import React from 'react';
import { PropTypes } from 'prop-types';
import { observer } from 'mobx-react';
import { Link } from 'react-router-dom';

import { utilsService } from '../../core/services/utils.service';
import AppStatusIndicator from '../app-status-indicator/app-status-indicator';

@observer
export class AppVersionNavigator extends React.Component {

	static propTypes = {
		appVersions: PropTypes.object,
		name: PropTypes.string,
		handleRatingsClick: PropTypes.func.isRequired,
		handleVersionSelect: PropTypes.func.isRequired,
		reviewsVisible: PropTypes.bool,
		selectedVersion: PropTypes.object.isRequired
	};

	static defaultProps = {
		appVersions: {},
		name: '',
		reviewsVisible: false
	}

	onRatingsClick = (e) => {
		e.preventDefault();
		this.props.handleRatingsClick();
	};

	onVersionClick = (e, version) => {
		e.preventDefault();
		e.currentTarget.blur();
		this.props.handleVersionSelect({
			versionNumber: version.version_num,
			saveId: version.saveId
		});
	};

	render () {
		return(
			<div className="app-version-navigator">
				<h5 className="app-version-navigator-app-name">
					{this.props.name}
				</h5>
				<a
					href=""
					className={`ratings-and-reviews-link walkthrough-app-details ${(this.props.reviewsVisible && 'inactive')}`}
					onClick={this.onRatingsClick}>
					Ratings &amp; Reviews
				</a>
				<h6 className="versions-heading">
					App Versions:
				</h6>
				<ul className="versions-list walkthrough-versions">
					{this.props.appVersions.versions && this.props.appVersions.versions.map((version, idx) => {
						const isSelected = !this.props.reviewsVisible && this.props.selectedVersion.versionNum === version.version_num;
						return (
							<li key={idx}>
								<Link
									to={utilsService.generateAppPageURI(version, 'view')}
									className={`version-link-button ${isSelected ? 'sidebar-active' : ''} `}
									onClick={(e) => {this.onVersionClick(e, version)}}>
									<div>Version {version.version_num}</div>
									<AppStatusIndicator status={version.custom_metadata.status} inactiveStatus={version.custom_metadata.statusReason} />
								</Link>
							</li>
						);
					})}
				</ul>
			</div>
		);
	}
}
